<template>
  <div class="h-100">
    <div class="h-100">
      <div class="d-inline-flex w-100" style="height:60px;">
        <div class="justify-content-start">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb comm-settings-top-nav m-0">
                  <li class="comm-icon-rtl">
                     <back-button  v-on:click.native="changeComponent('show-user')"></back-button>
                  </li>
                    <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{seletedUserName}}</li>
                </ol>
            </nav>
        </div>
      </div>
      <nav class="navbar navbar-expand-lg p-0">
          <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div class="navbar-nav w-100 top-nav-bar">
                  <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'users-info';" :class='(selectedUserComponent === "users-info")?"active":"inactive"'>{{$t('Basic Info')}}<span class="sr-only">(current)</span></a>
                  <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'users-privileges'" :class='(selectedUserComponent === "users-privileges")?"active":"inactive"'>{{$t('Privileges')}}</a>
                  <template v-if="selectedUserType.type != 'SystemAdmin'">
                    <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'bins-permissions'" :class='(selectedUserComponent === "bins-permissions")?"active":"inactive"'>{{$t('Bin Permissions')}}</a>
                    <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'catalog-permissions'" :class='(selectedUserComponent === "catalog-permissions")?"active":"inactive"'>{{$t('Catalog Permissions')}}</a>
                  </template>
                  <a class="nav-item nav-link w-50" v-on:click="selectedUserComponent = 'configure-retrieve'" :class='(selectedUserComponent === "configure-retrieve")?"active":"inactive"'>{{$t('Retrieve Settings')}}</a>
              </div>
          </div>
      </nav>
      <template v-if="selectedUserComponent == 'users-info'">
        <table class="table users-basic-info-table" style="background: transparent;height: calc(100% - 115px);display: inline-block;overflow: auto;">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 20%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div">{{$t('Username')}}</td>
              <td class="value-div d-inline-flex float-left m-0">
                <div class="w-100">
                  <div class="d-inline-block">
                    <div v-show="!isEditting('name')" class="d-inline-flex align-items-center">
                      <span>{{ selectedUserInfo.username }}</span>
                      <svg v-if="selectedUserID" @click="copyUserId" class="bi bi-copy copy-user-id-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <title>{{$t('Copy User ID')}}</title>
                        <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                      </svg>
                    </div>
                    <div class="config-desc">
                      {{$t('Is unique ID for the User and its non editable once it created')}}.
                    </div>
                    <!-- <edit-icon
                      @click.native="editBasicInfoField('name')"
                      v-show="!isEditting('name')"
                      class="editIcon"
                    ></edit-icon> -->
                  </div>
                  <input
                    minlength="3"
                    type="text"
                    v-model="postData.username"
                    v-show="isEditting('name')"
                    class="rounded text-light comm-input-field-style"
                    required
                    style="position: relative;
        bottom: 7px;"
                  />
                </div>
                <div v-show="isEditting('name')">
                  <div class="d-flex">
                    <save-icon
                      @click.native="saveBasicInfoField('username')"
                    ></save-icon>
                    <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">{{$t('Password')}}</td>
              <td class="value-div w-100 float-left m-0">
                <div style="display: inline-flex;width: 42%;">
                  <div style="position: relative;width:83%">
                    <div class="d-inline-flex">
                      <span v-show="!isEditting('password')">******</span>
                      <edit-icon
                        @click.native="editBasicInfoField('password')"
                        v-show="!isEditting('password')"
                        class="editIcon"
                      ></edit-icon>
                    </div>
                    <input
                      :type="passwordFieldType"
                      @input="validPasswordCheck"
                      v-show="isEditting('password')"
                      class="rounded text-light comm-input-field-style align-input-field"
                      v-model="postData.password"
                    />
                    <svg
                      width="2em"
                      height="1.5em"
                      style="position: absolute; inset-inline-end :1%; bottom: 8px"
                      v-show="isEditting('password')"
                      @click="switchVisibility"
                      type="password"
                      viewBox="0 0 16 16"
                      class="bi bi-eye ml-1 svg-icon"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <span v-show="!validPassword" class="pl-1 pt-1 validationmessage"
                    >
                    <template v-if="!isPasswordEnforced()">
                                {{$t('Empty Password')}}
                              </template>
                              <template v-else>
                                {{$t('Password Must be 8 characters with 1Uppercase, 1Lowercase, 1Numeric & 1Special char')}}
                              </template>
                    </span
                  >
                </div>
              </td>
            </tr>
            <tr v-show="isEditting('password')">
              <td class="key-div">{{$t('Verify Password')}}</td>
              <td class="value-div w-100 float-left m-0">
                <div style="display: inline-flex;width: 41%;">
                  <div class="w-100" style="position: relative">
                    <input
                      :type="verifypasswordFieldType"
                      @input="passwordVerificationCheck"
                      v-model="verifiedPassword"
                      class="rounded text-light comm-input-field-style align-input-field"
                    />
                    <svg
                      width="2em"
                      height="1.5em"
                      style="position: absolute; inset-inline-end :1%; bottom: 8px"
                      @click="switchVisibilityVerifyPassword"
                      type="password"
                      viewBox="0 0 16 16"
                      class="bi bi-eye ml-1 svg-icon"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                      />
                    </svg>
                  </div>
                  <div v-show="isEditting('password')">
                    <div class="d-flex">
                      <save-icon
                        @click.native="saveBasicInfoField('password')"
                      ></save-icon>
                      <cancel-icon
                        @click.native="cancelBasicInfoField()"
                      ></cancel-icon>
                    </div>
                  </div>
                </div>
                <div>
                  <span
                    v-show="!matchedPassword"
                    class="pl-1 pt-1 validationmessage"
                    >{{$t('Passwords are not matching')}}!!</span
                  >
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">{{$t('User type')}}</td>
              <td class="value-div d-flex m-0">
                <div class="w-100" style="display:contents">
                  <div class="d-inline-flex">
                    <span v-show="!isEditting('user_type')">{{
                      selectedUserType.label
                    }}</span>
                    <!-- <edit-icon
                      @click.native="editBasicInfoField('user_type')"
                      v-show="!isEditting('user_type')"
                      class="editIcon"
                    ></edit-icon> -->
                  </div>
                  <!-- <Multiselect
                    v-show="isEditting('user_type')"
                    :value="selectedUserType.label"
                    :options="userTypes"
                    :searchable="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    @select="enableTabsByUserType($event)"
                    :label="label"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Select Field Type"
                    :track-by="type">
                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                      <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                    </div>
                  </Multiselect> -->
                </div>
                <!-- <div v-show="isEditting('user_type')">
                  <div class="d-flex">
                    <save-icon
                      @click.native="saveBasicInfoField('user_type')"
                    ></save-icon>
                    <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                  </div>
                </div> -->
              </td>
            </tr>
            <tr>
              <td class="key-div">Email</td>
              <td class="value-div w-30 float-left m-0">
                <div style="display: inline-flex" class="w-100">
                  <div class="w-100">
                    <div class="d-inline-flex">
                      <span v-if="!isEditting('email') && selectedUserInfo.email != undefined && selectedUserInfo.email.length">{{
                        selectedUserInfo.email
                      }}</span>
                      <span v-else-if="!isEditting('email')" class="empty-field-text-styles">NONE</span>
                      <edit-icon
                        @click.native="editBasicInfoField('email')"
                        v-show="!isEditting('email')"
                        class="editIcon"
                      ></edit-icon>
                    </div>
                    <input
                      type="email"
                      v-model="postData.email"
                      v-show="isEditting('email')"
                      @input="validEmailCheck($event)"
                      class="rounded text-light comm-input-field-style align-input-field"
                    />
                  </div>
                  <div v-show="isEditting('email')">
                    <div class="d-flex">
                      <save-icon
                        @click.native="saveBasicInfoField('email')"
                      ></save-icon>
                      <cancel-icon
                        @click.native="cancelBasicInfoField()"
                      ></cancel-icon>
                    </div>
                  </div>
                </div>
                <div>
                  <span v-show="!validEmail" class="pl-1 pt-1 validationmessage"
                    >Invalid email address</span
                  >
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">Contact Number</td>
              <td class="value-div w-30 float-left m-0">
                <div style="display: inline-flex" class="w-100">
                  <div class="w-100">
                    <div class="d-inline-flex">
                      <span v-if="!isEditting('number') && selectedUserInfo.contact_number != undefined && selectedUserInfo.contact_number.length">{{
                        selectedUserInfo.contact_number
                      }}</span>
                      <span v-else-if="!isEditting('number')" class="empty-field-text-styles">NONE</span>
                      <edit-icon
                        @click.native="editBasicInfoField('number')"
                        v-show="!isEditting('number')"
                        class="editIcon"
                      ></edit-icon>
                    </div>
                    <input
                      type="number"
                      min="0"
                      id="contact_number_input"
                      @input="validContactNumberCheck"
                      v-model="postData.contact_number"
                      v-show="isEditting('number')"
                      class="rounded text-light comm-input-field-style align-input-field"
                    />
                  </div>
                  <div v-show="isEditting('number')">
                    <div class="d-flex">
                      <save-icon
                        @click.native="saveBasicInfoField('contact_number')"
                      ></save-icon>
                      <cancel-icon
                        @click.native="cancelBasicInfoField()"
                      ></cancel-icon>
                    </div>
                  </div>
                </div>
                <div>
                  <span v-show="!validNumber && postData.contact_number.length > 0" class="pl-1 pt-1 validationmessage"
                    >Invalid contact number</span
                  >
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">Account Status</td>
              <td class="value-div" style="display: flex;justify-content: flex-start;margin-inline-start: 15px;">
                <div class="custom-control custom-switch">
                  <input
                    v-on:click="toggleCheckbox"
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch1"
                    :disabled="selectedUserID == getLoggedInUserId()"
                    :checked='isActiveUser'
                  />
                  <label class="custom-control-label" for="customSwitch1">
                    <span
                      v-if="isActiveUser"
                      class="text-success"
                      >Active</span
                    >
                    <span v-else class="text-danger">Inactive</span></label
                  >
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">Login Status</td>
              <td class="text-success value-div">
                <span
                  v-if="loginStatus"
                  class="text-success"
                  style="position: relative; bottom: 3px"
                  >Online</span
                >
                <span v-else class="text-danger">Offline</span>
                <button
                  type="button"
                  class="btn text-danger border-0 force-logout"
                  v-show="loginStatus"
                  @click="forceLogout()"
                >
                  Force logout
                </button>
              </td>
            </tr>
            <tr v-if="globalSettingsFromStartup.enable_department &&  selectedUserType.type != 'SystemAdmin'" >
              <td class="key-div" style="vertical-align:top">{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</td>
              <td class="value-div float-left m-0" style="width:60%;position: relative;">
                <div style="display: inline-flex" class="w-100">
                  <div class="w-100">
                    <div v-if="!isEditting('department')" class="d-inline-flex" style="flex-flow: wrap;">
                      <template v-if="!isEditting('department') && selectedUserInfo.department_info != undefined && selectedUserInfo.department_info.length">
                        <span class="selected-tags-style" style="padding-inline-end: 10px !important;" v-for="dInfo in selectedUserInfo.department_info" :key="dInfo._id">
                          <span v-if="'logo' in dInfo && dInfo.logo" class="img-span"><img :src="getProxyConvertedURL(dInfo.logo)" /></span>
                          {{dInfo.name}}</span>
                      </template>
                      <span v-else-if="!isEditting('department')" class="empty-field-text-styles">NONE</span>
                      <edit-icon
                        @click.native="editBasicInfoField('department')"
                        v-show="!isEditting('department')"
                        class="editIcon"
                      ></edit-icon>
                    </div>
                    <div v-if="isEditting('department')" style="display:flex;align-items:center">
                      <div style="display:flex !important;flex-direction:column;width:100%;justify-content:center">
                        <departmentsCommonComponent :isMultiselectDropdown='true' :inEditMode='true' :selectedProject="selectedUserInfo.department_info" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                        <span @click="openManageDepartment = true" class="manage-department-styles">Manage {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</span>
                      </div>
                        <div>
                          <div class="d-flex" style="justify-content:center;position:relative;bottom:10px">
                            <save-icon
                              @click.native="saveBasicInfoField('department')"
                            ></save-icon>
                            <cancel-icon
                              @click.native="cancelBasicInfoField()"
                            ></cancel-icon>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="key-div">Group</td>
              <td class="value-div">
                <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                  <div v-on:click="enableUserGroupBrowser()" style="width: 100px; padding: 5px; margin-bottom: 8px; position: relative;text-align:center">
                    <div class="add-user-icon-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                      </svg>
                    </div>
                    <div>{{$t('Add to group')}}</div>
                  </div>
                  <div v-for="groupInfo in selectedGroupIdNameList" :key="groupInfo._id" class="comm-tags-class" style="width: 100px; padding: 5px; margin-bottom: 8px; position: relative;text-align:center">
                      <!-- <div class="icons-with-text-wrapper"> -->
                        <div class="user-name-or-image user-name" :style="style(groupInfo.group_name)">{{ groupInfo.group_name.split("")[0] }}
                        </div>
                          <!-- </div> -->
                          <div style="text-align:center;word-break: break-all;">{{groupInfo.group_name}}</div>
                        <cancel-icon class="delete-user-icon" @click.native="toggleSelectedGroupInList(groupInfo._id)"></cancel-icon>
                      </div>
                  </div> 
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <users-privileges v-if="selectedUserComponent == 'users-privileges'" :userType="selectedUserType.type" v-bind="currentProperties"></users-privileges>
      <bin-permissions v-if="selectedUserComponent == 'bins-permissions'" v-bind="currentProperties" :binTypesFilter="['asset','deployment']"></bin-permissions>
      <catalog-permissions v-if="selectedUserComponent == 'catalog-permissions'" v-bind="currentProperties"></catalog-permissions>
      <configure-retrieve v-if="selectedUserComponent == 'configure-retrieve'" v-bind="currentProperties"></configure-retrieve>
    </div>
  <browse-user-groups v-if="userGroupBrowser" :newUser="false" :selectedUGIdNameList="selectedGroupIdNameList" @close="updateUserGroups"></browse-user-groups>
  <ManageDepartments v-if="openManageDepartment" @close="openManageDepartment = false"></ManageDepartments>
  </div>
</template>

<script>
import {mapMutations, mapActions, mapGetters } from "vuex";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";
import UserPrivileges from "../users/UserPrivileges.vue";
import BinPermissions from "../users/BinsPermissions.vue"
import CatalogPermissions from "../users/CatalogPermissions.vue"
import RetrieveSettings from "../users/ConfigureRetrieve.vue"
import BackButton from "../core/backButton.vue";
import {NotifierConstants} from "../../components.constants.js";
import BrowseGroups from "../userGroups/BrowseUserGroups.vue"
import ManageDepartments from "./ManageDepartments.vue";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";

export default {
  data() {
    return {
      userGroupBrowser: false,
      selectedGroupIdNameList:[],
      selectedUserType:{label:"System User",type:"SystemUser"},
      userTypes:[
        {label:"System User",type:"SystemUser"},
        {label:"System Administrator",type:"SystemAdmin"},
        {label:"Customer",type:"Client"},
      ],
      selectedUserInfo: {},
      postData: {},
      loginStatus: false,
      save: false,
      activeField: null,
      editingKey: null,
      password: "",
      selectedUserComponent:'users-info',
      passwordFieldType: "password",
      verifypasswordFieldType: "password",
      validPassword: true,
      validEmail: true,
      validNumber: true,
      matchedPassword: true,
      verifiedPassword: null,
      emailRegex: new RegExp(
        /^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/
      ),
      passwordRegex: new RegExp(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
      ),
      //eslint-disable-next-line
      contactNumber: new RegExp(/(^\+[\d]{2}[\d]{10})|(^[\d]{10}$)|(^[\d]{3}[\-]{1}[\d]{8}$)/),
      selectedDepartments:null,
      openManageDepartment:false,
    };
  },
  components: {
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "users-privileges": UserPrivileges,
    "bin-permissions": BinPermissions,
    "catalog-permissions": CatalogPermissions,
    "configure-retrieve":RetrieveSettings,
    "back-button":BackButton,
    "browse-user-groups": BrowseGroups,
    ManageDepartments,
    departmentsCommonComponent
  },
  computed:{
      globalSettingsFromStartup:{
        get(){
          return this.$store.state.startUpData.startUpDataDetails;
        }
      },
     currentProperties() {
      //Dynamically send props
        return { selectedUserID: this.selectedUserID, selectedUserInfo: this.selectedUserInfo };
      },
    isActiveUser(){
      return this.selectedUserInfo.status === 'active'
    }
  },
  props: ["selectedUserID","seletedUserName"],
  methods: {
    async copyUserId() {
      if (!this.selectedUserID) {
        this.$toast.error(this.$t("User ID not available"));
        return;
      }

      try {
        await navigator.clipboard.writeText(this.selectedUserID);
        this.$toast.info(this.$t("User ID copied"));
      } catch (error) {
        const input = document.createElement("textarea");
        input.value = this.selectedUserID;
        input.style.position = "fixed";
        input.style.opacity = "0";

        document.body.appendChild(input);
        input.select();

        const copied = document.execCommand("copy");
        document.body.removeChild(input);

        copied
          ? this.$toast.info(this.$t("User ID copied"))
          : this.$toast.error(this.$t("Failed to copy user ID"));
      }
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    updateSelectedDepartments(values){
      this.selectedUserInfo.department_info = values;
    },
    updateUserGroups(groupInfo, isBrowseCancelled = false){
      let exstngBrowsedGroupList = []
      Object.assign(exstngBrowsedGroupList, this.selectedGroupIdNameList);
      let browsedGroupList = []
      if(groupInfo && Array.isArray(groupInfo) && groupInfo.length >0){
        browsedGroupList = groupInfo
      }
      if(isBrowseCancelled){
        //browser closed manually, hence skipping user group validation and updates
        this.userGroupBrowser = false
        return
      }
      let failedUserGroups = []

      //check added to verify whether user is removed from existing user or not , from the group browse model.
      if(exstngBrowsedGroupList && Array.isArray(exstngBrowsedGroupList) && exstngBrowsedGroupList.length>0){
        for(let exstngUG of exstngBrowsedGroupList){
          let gIndx = browsedGroupList.findIndex(op=>op._id == exstngUG._id)
          if(gIndx == -1){
            //existing group is deselected, hence removing the user from group
            this.toggleSelectedGroupInList(exstngUG._id, false)
          }
        }
      }
      for(let eachUG of browsedGroupList){
        let payload = {}
        let userIdList = eachUG.user_list;
        //updating usergroup only if user doesn't exists in group
        if(!userIdList.includes(this.selectedUserID)){
          userIdList.push(this.selectedUserID)
          payload["params"] = { _id: eachUG._id};
          payload["user_list"] = userIdList;
          this.updateExistingUserGroup(payload).then((uGdata) => {
            if(!Utils.isAcceptedStatusCode(uGdata.statusCode)){
              failedUserGroups.append(eachUG.group_name)
            }
          })
        }
      }
      this.selectedGroupIdNameList = groupInfo
      if(failedUserGroups && failedUserGroups.length > 0){
        this.$toast.error(`Failed to add/remove user in "${failedUserGroups.join(',')}" group(s).`)
      }else{
        this.$toast.success(`User "${this.selectedUserInfo.username}" updated successfully. `)
      }
      this.userGroupBrowser = false
    },
    enableUserGroupBrowser(){
      this.userGroupBrowser = true
    },
    toggleSelectedGroupInList(gorupId, showToastMessage = true){
      if(this.selectedGroupIdNameList && Array.isArray(this.selectedGroupIdNameList) && this.selectedGroupIdNameList.length >0){
        let matchedGL = this.selectedGroupIdNameList.find(op=>op._id == gorupId)
        if(matchedGL){
          let groupInfo = matchedGL
          if(groupInfo){
              if (showToastMessage && !confirm(`Are You sure you want to remove the usergroup "${groupInfo.group_name}"?`)) {
                return
              }
                let payload = {}
                let userIdList = groupInfo.user_list;
                if(userIdList.includes(this.selectedUserID)){
                  userIdList.splice(userIdList.indexOf(this.selectedUserID), 1)
                  payload["params"] = { _id: groupInfo._id};
                  payload["user_list"] = userIdList;
                  this.updateExistingUserGroup(payload).then((data) => {
                    if(Utils.isAcceptedStatusCode(data.statusCode)){
                      if(showToastMessage){
                        this.$toast.success(`User "${this.selectedUserInfo.username}" updated successfully.`);
                      }
                      this.selectedGroupIdNameList = this.selectedGroupIdNameList.filter(op=>op._id != gorupId)
                    }else{
                      if(showToastMessage){
                        this.$toast.error(data.message);
                      }
                    }
                  })
                }
          }
        }
      }
      
    },
    enableTabsByUserType(userType){
      this.selectedUserType.label = userType.label;
      this.selectedUserType.type = userType.type;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    switchVisibilityVerifyPassword() {
      this.verifypasswordFieldType =
        this.verifypasswordFieldType === "password" ? "text" : "password";
    },
    editBasicInfoField(keyName) {
      this.editingKey = keyName;
      this.validPassword = true;
      this.validEmail = true;
      this.validNumber = true;
      this.matchedPassword = true;
    },
    toggleCheckbox() {
      if (this.selectedUserID == this.getLoggedInUserId()) {
        alert("Current logged in user can not be disabled. ");
        return;
      }
      if (this.postData.status === "active") {
        this.postData.status = "disabled";
      } else {
        this.postData.status = "active";
      }
      this.saveBasicInfoField("status");
    },
    getOnlyIdsArr(arrayOfDictionaries){
        return arrayOfDictionaries.map(item => item._id);
    },
    saveBasicInfoField(field) {
      // Object.assign(person, this._originalPerson);
      let payload = {};
      if (
        field == "username" &&
        (typeof this.postData[field] == "undefined" ||
          this.postData[field].length <= 0)
      ) {
        alert("Please add valid user name. ");
        this.isEditting('name')
        return;
      }
      if (
        field == "password" &&
        (!this.validPassword || !this.matchedPassword)
      ) {
        alert("Please add valid password. ");
        this.isEditting('password')
        return;
      }
      if (field == "email" && this.postData[field].trim().length > 0 && !this.validEmail) {
        alert("Please add valid email. ");
        // this.validEmail = true;
        // this.isEditting('email')
        return;
      }
      if (field == "contact_number" && this.postData[field].trim().length > 0 && !this.validNumber) {
        alert("Please add valid contact number. ");
        // this.validNumber = true;
        // this.isEditting('number')
        return;
      }
      
      this.editingKey = null;
      if(field == "user_type"){
        payload[field] = this.selectedUserType.type;
      }else if(field == "department"){
        payload[field] = this.getOnlyIdsArr(this.selectedUserInfo.department_info);
      }else{
        payload[field] = this.postData[field];
      }

      this.validPassword = true;
      this.validEmail = true;
      this.validNumber = true;
      payload.params = { user_id: this.selectedUserID };
      this.updateExistingUser(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          if (data.message.includes("Failed")) {
            this.$toast.warning(data.message);
          } else {
            if(this.getLoggedInUserId() != this.selectedUserID){
              this.$toast.success(data.message);
            }
            if(this.selectedGroupIdNameList && Array.isArray(this.selectedGroupIdNameList) && this.selectedGroupIdNameList.length >0){
              let failedUserGroups = []
              for(let eachUG of this.selectedGroupIdNameList){
                let payload = {}
                let userIdList = eachUG.user_list;
                if(!userIdList.includes(this.selectedUserID)){
                  userIdList.push(this.selectedUserID)
                  payload["params"] = { _id: eachUG._id};
                  payload["user_list"] = userIdList;
                  this.updateExistingUserGroup(payload).then((uGdata) => {
                    if(!Utils.isAcceptedStatusCode(uGdata.statusCode)){
                      failedUserGroups.append(eachUG.group_name)
                    }
                  })
                }
              }
              if(failedUserGroups && failedUserGroups.length > 0){
                this.$toast.error("Failed to add user in " + failedUserGroups.join(',') + " group(s).")
              }else{
                this.$toast.success(`User "${this.selectedUserInfo.username}" updated successfully.`);
              }
            }
            this.refreshUserInfo();
          }
        } else {
          this.$toast.error(data.message);
        }
      });
      delete this.postData["password"];
      this.verifiedPassword = "";
    },
    isPasswordEnforced(){
      return JSON.parse(Utils.getLocalStorageValue('enable_password_enforcement'))
    },
    validPasswordCheck() {
      if(this.isPasswordEnforced()){
      if (
        this.postData.password.length != 0 &&
        this.passwordRegex.exec(this.postData.password) != null
      ) {
        this.validPassword = true;
        this.passwordVerificationCheck();
      } else {
        this.validPassword = false;
      }
      this.matchedPassword = false;
      }else if(this.postData.password.trim().length > 0){
        this.validPassword = true
        this.passwordVerificationCheck();
      }else{
        this.validPassword = false
      }
    },
    passwordVerificationCheck() {
      if (
        this.verifiedPassword != null &&
        this.verifiedPassword == this.postData.password &&
        this.verifiedPassword.length != 0
      ) {
        this.matchedPassword = true;
      } else {
        this.matchedPassword = false;
      }
    },
    validEmailCheck(e) {
      if (
        e.target.value.length > 0 &&
        this.emailRegex.exec(this.postData.email) != null
      ) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    validContactNumberCheck() {
      if (
        this.postData.contact_number.length > 0 &&
        this.contactNumber.exec(this.postData.contact_number) != null        
      ) {
        this.validNumber = true;
      } else {
        this.validNumber = false;
      }
    },
    cancelBasicInfoField() {
      this.editingKey = null;
      this.validPassword = true;
      this.validEmail = true;
      this.validNumber = true;
      this.matchedPassword = true;
    },
    isEditting(keyName) {
      return keyName === this.editingKey;
    },
    forceLogout() {
      let payload = {};
      payload.params = { query: { user_id: this.selectedUserID } };
      this.forceLogoutUser(payload).then((data) => {
        console.log(`[forceLogout][Userinfo][Force Logout Status->${data}]`);
        this.refreshUserInfo();
      });
    },
    changeComponent(comp){
            this.$emit("changeSelectedComponent", comp);
            let enableAddGroupButton = false
            if(this.tableType == 'show-user-groups'){
                    this.$emit("changeSelectedComponent",comp)
                    this.$refs.userGroupRef.changeSelectedComponent(comp)
                if(comp == "show-user-groups"){
                    enableAddGroupButton = true
                }else if(comp == "user-group-info"){
                    enableAddGroupButton = true
                }
            }
            this.showUserGroupAddButton = enableAddGroupButton
      },
    refreshUserInfo() {
      let payload = {};
      payload.params = { userId: this.selectedUserID };
      this.getUserInfoFromServer(payload).then((resp) => {
        if (!Utils.isAcceptedStatusCode(resp.statusCode)) {
          this.$toast.error(resp.message);
        } else {
          this.selectedUserInfo = resp.user;
          if(Object.keys(this.selectedUserInfo).includes("user_type")){
            this.selectedUserType.type = this.selectedUserInfo["user_type"];
            if(this.selectedUserType.type == "SystemUser"){
              this.selectedUserType.label = "System User"
            }else if(this.selectedUserType.type == "SystemAdmin"){
              this.selectedUserType.label = "System Administrator"
            }else if(this.selectedUserType.type == "Client"){
              this.selectedUserType.label = "Customer"
            }
          }
          Object.assign(this.postData, this.selectedUserInfo);
          delete this.postData["password"]
        }
      });
      this.checkUserLoginStatus({
        params: { query: { user_id: this.selectedUserID } },
      }).then((resp) => {
        this.loginStatus = resp.logged_in;
      });
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let user_info = notification.message
        if (user_info._id == this.selectedUserInfo._id){
          Object.assign(this.selectedUserInfo, user_info)   
          Object.assign(this.postData, user_info)   
          delete this.postData["password"]
        }
      }
    },

    handleUserGroupsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let groupInfo = notification.message
      if(groupInfo){
          if(notification.message_type == NotifierConstants.userGroupRemovedNotification){
            this.selectedGroupIdNameList = this.selectedGroupIdNameList.filter(op=>op._id != groupInfo._id);
          }else{
            let indx = this.selectedGroupIdNameList.findIndex(op=>(op.user_list.includes(this.selectedUserID) && op._id == groupInfo._id));
            if(indx < 0){
              if(groupInfo.user_list.includes(this.selectedUserID)){
                this.selectedGroupIdNameList.push(groupInfo);
              }
            }else{
              if("removed_user_list" in groupInfo){
                if(groupInfo.removed_user_list && groupInfo.removed_user_list.includes(this.selectedUserID)){
                    this.selectedGroupIdNameList.splice(indx, 1);
                }
              }else{
                this.$set(this.selectedGroupIdNameList, indx, groupInfo);
              }
            }
           
          }
      }  
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[ NotifierConstants.userModifiedNotification],
            callback:this.handleUsersNotification,
            parent:"UserInfo"})
            this.addWSEventListener({eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,parent:"UserInfo"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[ NotifierConstants.userModifiedNotification],
            callback:this.handleUsersNotification,
            parent:"UserInfo"})
    },
    ...mapActions("users", [
      "getUserInfoFromServer",
      "updateExistingUser",
      "checkUserLoginStatus",
      "forceLogoutUser",
    ]),
    ...mapGetters("users", ["getLoggedInUserId"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("userGroups", ["updateExistingUserGroup"]),
  },
  created() {
    if(Object.keys(this.getStartUpDataFromInCache()).includes("user_groups")){
      // User_list checked added here, to handle the groups not having user_list
      this.selectedGroupIdNameList = this.getStartUpDataFromInCache()["user_groups"].filter(op=>(op.user_list && op.user_list.includes(this.selectedUserID)));
    }
    this.registerforWebsocketNotifications()
    this.refreshUserInfo();
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  },
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;


.empty-field-text-styles{
  color:$none-text-color;
}

.svg-icon{
  color:$dull-text-color !important;
}

.editIcon {
  margin-inline-start: 9px;
}
#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.users-basic-info-table {
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    display: inline-block;
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
      width:10%;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 42%;
      font-weight: 500;
      span{
        padding-inline-start:11px;
      }
    }
  }
}

.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.custom-control-label::before {
  background-color: $primary-background;
}

table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.disablefield {
  border: none !important;
  pointer-events: none;
}

.force-logout {
  position: relative;
  inset-inline-start:5px;
  bottom: 4px;
}
.force-logout:hover {
  text-decoration: underline;
}
.activestatus {
  color: #28a745 !important;
}
.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size:15px;
}
.top-nav-bar{
    background: $primary-background;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}
.align-input-field{
  margin-top:-8px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items: center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

// .custom-switch{
//       padding-inline-start: 5%;
// }
.config-desc{
  color: $dull-text-color;
    width: 100%;
    text-align: initial;
    margin-inline-start: 11px;
}

.add-user-icon-wrapper{
    height: 57px;
    width: 60px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
    top:-3px;
    svg{
      color: $add-button-text-color !important;
      margin: 0px auto;
      width: 100%;
      position: relative;
      // top: -6px;
    }
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 17px;
  top: -2px;
  height: 23px;
  width: 23px;
  border: $border-color;
  background: $primary-background;
  border-radius: 30px;
  color: $text-color;
}
.delete-user-icon{
  visibility: hidden;
}
.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}
.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}
.icons-with-text-wrapper{
    height: 45px;
    width: 45px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    border: $border-color;
    svg{
      margin: 0px auto;
      width: 100%;
      position: relative;
      top: -6px;
    }
}
.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
    height:40px;
    }
  }
}



.user-name-or-image{
    // height: 30px;
    // width: 30px;
    // border: $border-color;
    // border-radius: 10px;
    // text-align: center;
    // line-height: 28px;
    // text-transform: uppercase;
    // margin-top: 3px;
    // top:4px !important;
    height: 60px;
    width: 60px;
    border: 1px solid #4a4a4a;
    border-radius: 10px;
    text-align: center;
    text-transform: uppercase;
    margin: 0 auto !important;
    font-size: 28px;
    line-height: 60px;
}
.user-name{
    margin-inline-end: 10px;
    position: relative;
    // bottom: 7px;
}

.selected-tags-style{
  background: $bg-color-on-hover;
  border: 1px solid #363636;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 25px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 5px !important;
  justify-content: center;
  padding-top: 2px !important;
  padding-inline-end: 4px !important;
  margin-bottom: 4px !important;
  align-items: center !important;
  .remove-tag{
      line-height:18px;
      color: #858585;
  }
 }

 .manage-department-styles{
  float: inline-start;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  color:#909b43cf;
  width: 100%;
  text-align: end;
}

.manage-department-styles:hover{
  text-decoration: underline;
}

span.img-span{
width: 40px;
height: 40px;
display: inline-flex;
padding: 2px !important;
margin-inline-end:4px;
align-items: center;
justify-content: center;
    img{
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px;
        object-fit: contain;
        display: inline-block;
    }
}

.copy-user-id-icon {
  margin-inline-start: 8px;
  color: $secondary-text-color;
  cursor: pointer;
}

.copy-user-id-icon:hover {
  color: $active-blue;
}

</style>